export type PhoneMaskFormat = 'parentheses' | 'dashes';

export const applyPhoneMask = (phoneNumberString: string, format: PhoneMaskFormat = 'parentheses'): string => {
  let cleaned = phoneNumberString.replace(/\D/g, '');

  if (cleaned.startsWith('1') && cleaned.length === 11) {
    cleaned = cleaned.slice(1);
  }

  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    if (format === 'dashes') {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    // Default: parentheses format
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phoneNumberString;
};
